import { render, staticRenderFns } from "./AffiliateProfile.vue?vue&type=template&id=182d3fea&"
import script from "./AffiliateProfile.vue?vue&type=script&lang=js&"
export * from "./AffiliateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports